import React, {Component} from 'react';
import './ImageControl.css';
import Dropzone from 'react-dropzone'
import Loading from './Loading';

/**
 * 1px transparent data URL image as placeholder
 */
const PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
const RETRY_DELAY = 2000; // ms

/**
 * Image control that supports drag/drop upload, preview of the image and actual render of the image if available.
 * 
 * Will make 3 retries to render an image if available, allowing for race conditions in upload etc
 */
class ImageControl extends Component {
	constructor() {
		super();

		this.state = {
			attempting: true,
			retries: 3
		};

		/**
		 * When an error occurs when loading the image, make another attempt in a few seconds.
		 */
		this.onImgError = () => {
			// Do we have retries remaining?
			if (this.state.retries > 0) {
				this.setState({
					attempting: false,
					retries: this.state.retries ? this.state.retries - 1 : 3
				});
				setTimeout(this.makeAttempt, RETRY_DELAY);
			}
		};

		this.makeAttempt = () => {
			this.setState({
				attempting: true
			});
		};
	}
	
	render() {
		const {backgroundUrl, onDrop, onDropRejected, disabled} = this.props;
		const {attempting} = this.state;

		// Only show realy image when not retrying, or re-attempting during retry loop.
		const src = attempting ? backgroundUrl : PLACEHOLDER;

		return (
			<Dropzone
				className={`ImageControl ${disabled ? 'disabled' : ''}`}
				accept="image/jpeg, image/png"
				multiple={false}
				disableClick={true}
				onDrop={onDrop}
				onDropRejected={onDropRejected}
				disabled={disabled}
				style={{backgroundImage: backgroundUrl ? `url('${src}')` : undefined}}
				maxSize={1048576}
			>
				{/* Note; img not actually rendered (bg url used for that), Only used to detect errors */}
				{backgroundUrl ? (<img style={{display: 'none'}} src={src} onError={this.onImgError} />) : undefined}
				{backgroundUrl ? undefined : (disabled ? (
					<div className="ImageControl-placeholder">
						<Loading />
						<p>Waiting for upload token</p>
					</div>
				) : (<p className="ImageControl-placeholder">Click or drag/drop a file here to upload</p>))}
			</Dropzone>
		);
	}
}

export default ImageControl;


// WEBPACK FOOTER //
// ./src/widgets/ImageControl.js